import { Attachment } from './attachment';

export interface NoteBase {
  content: string;
  category_id: number;
}

export interface NoteCreate extends NoteBase {
  attachments?: number[];
}

export interface NoteUpdate extends NoteBase {}

export interface Note extends Omit<NoteBase, 'attachments'> {
  id: number;
  created_at: string; // ISO string from backend
  updated_at: string; // ISO string from backend
  attachments: Attachment[];
  category_breadcrumb: string[];
}

export enum NoteOrderBy {
  created_at = 'created_at',
  updated_at = 'updated_at'
}

export enum NoteOrder {
  asc = 'asc',
  desc = 'desc'
}

export interface NoteFilter {
  category_id?: number | null;
  search?: string;
  start_date?: string;
  end_date?: string;
  order_by?: NoteOrderBy;
  order?: NoteOrder;
  skip?: number;
  limit?: number;
  isApplied?: boolean;
} 